import { render, staticRenderFns } from "./FormInputFile.vue?vue&type=template&id=cb77388a"
import script from "./FormInputFile.vue?vue&type=script&lang=ts"
export * from "./FormInputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports